import { Box, Stack } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'

import PageErrorBoundary from '~/components/pageErrorBoundary'
import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'
import { isAbcFitnesssDomain, isLibbyDomain } from '~/features/partners/utils'
import AbcFitnessAuthFeaturesPanel from '~/layouts/auth/abcFitnessAuthFeaturesPanel'
import Footer from '~/layouts/auth/footer'
import Logo from '~/layouts/auth/header/logo'
import ReplifyAuthFeaturesPanel from '~/layouts/auth/replifyAuthFeaturesPanel'
import { TNavigateState } from '~/models/auth'
import rem from '~/utils/ui'

function AuthLayout() {
  const { state } = useLocation() as { state: TNavigateState | null }
  const isPartner = !isLibbyDomain()
  const isAbcFitness = isAbcFitnesssDomain()

  const showReplifySections = !(isPartner || state?.isPartnerThemed)

  // Need to decide what to wrap if partner themed
  const renderWrapper = () => {
    if (state?.isPartnerThemed || isPartner) {
      return (
        <PartnerThemeWrapper>
          <PageErrorBoundary>
            <Outlet />
          </PageErrorBoundary>
        </PartnerThemeWrapper>
      )
    }

    return (
      <PageErrorBoundary>
        <Outlet />
      </PageErrorBoundary>
    )
  }

  const renderFeatures = () => {
    if (showReplifySections) {
      return <ReplifyAuthFeaturesPanel />
    }

    if (isAbcFitness) {
      return (
        <PartnerThemeWrapper>
          <AbcFitnessAuthFeaturesPanel />
        </PartnerThemeWrapper>
      )
    }

    return null
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateRows: '1fr',
        gridAutoFlow: 'row',
        gridAutoRows: 'auto',
        minHeight: '100dvh',
        maxHeight: { md: '100dvh' },
      }}
    >
      <Stack
        direction={{ xxxs: 'column', md: 'row' }}
        useFlexGap
        sx={{ width: '100%', overflow: { md: 'hidden' } }}
      >
        <Stack sx={{ width: '100%', overflow: 'auto' }}>
          <Box sx={{ ml: 2, mt: 1 }}>
            <Logo />
          </Box>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              paddingBlock: { xxxs: rem(100), md: 0 },
              paddingInline: { xxxs: rem(24), md: 0 },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'center',
                width: '100%',
                maxWidth: rem(384),
              }}
            >
              {renderWrapper()}
            </Box>
          </Box>
        </Stack>
        {renderFeatures()}
      </Stack>
      {showReplifySections && <Footer />}
    </Box>
  )
}

export default AuthLayout
